import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, List, ListItem, ListItemText, Popover, Tooltip } from '@mui/material';
import * as React from 'react';
import { IB } from '../../page/portal/setting/SettingPanel';
import { Wysiwyg } from '@mui/icons-material';
import Service from '../../../util/Service';

export default function FormCompPopover(props) {

    const { refDiv } = props;
    const [openCode, setOpenCode] = React.useState(false);
    const [code, setCode] = React.useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [clonedContent, setClonedContent] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'formComp-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            const s = window.getSelection();
            if (s.rangeCount === 0) {
                handleClose();
                return;
            }
            if (s.rangeCount > 0 && checkValidEditor()) {
                const range = s.getRangeAt(0);
                const cc = range.startContainer;
                setClonedContent(cc);
            }
        }
    }, [open]);

    const checkValidEditor = () => {
        const s = window.getSelection();
        if (s.rangeCount > 0) {
            const range = s.getRangeAt(0);
            const cc = range.startContainer;
            let pai = cc.parentNode;
            if(pai.id === "very2Editor") return true;
            while ( pai.id !== 'very2Editor'){
                pai = pai.parentNode; 
                if(pai.id === "very2Editor") return true;
                if( pai.id === 'root')break;
                if( pai.tagName === 'BODY')break;
            }
            return false;
        }
        return false;
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    function handleCloseCode(){
        setOpenCode(false);
    }
    function handleAddComponente(componente){
        const c = createComp(componente);
        if( clonedContent){
            clonedContent.replaceWith(c);
        }else{
            refDiv.current.append( c );
        }
        handleClose();
    }
    function buscaCodigoRefUpload(){
        Service.GET("/api/security/model/uploadField").then(r => {
            if (r.success) {
                console.log(r);                
                // const div = document.createElement("div");
                // div.innerHTML = r.html;                
                // refDiv.current.appendChild(div);
                // handleClose();
                // refreshEditor();
                // alert( r.html )
                setCode(r.html);
                setOpenCode(true);
            } else {
                alert(r.msg);
                // setOpenSnack(true);
            }
        })
    }
    function createComp(comp){
        if( comp === 'btn'){
            const cmp = document.createElement('button');
            cmp.className = "pd-action-button";
            if( clonedContent && clonedContent.textContent.length > 0){
                cmp.textContent = clonedContent.textContent;
            }else{
                const els = refDiv.current.getElementsByTagName('button');
                cmp.textContent = "Btn-"+(els.length+1);
            }
            return cmp;
        }
        if( comp === 'textfield'){
            const els = document.querySelectorAll('[type="textfield"]');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');            
            if( clonedContent && clonedContent.textContent.length > 0){
                cmp.innerHTML = 
`<label for="${"text_"+qtd}">${clonedContent.textContent}</label>
<input type="textfield" id="${"text_"+qtd}" class="pd-field"/>`;
            }else{
                cmp.innerHTML = 
`<label for="${"text_"+qtd}">${"TextField-"+(qtd+1)}</label>
<input type="textfield" id="${"text_"+qtd}" class="pd-field"/>`;
                
            }
            return cmp;
        }
        if( comp === 'textarea'){
            const els = document.querySelectorAll('[type="textarea"]');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');     
            // cmp.className = "pd-textarea";
            if( clonedContent && clonedContent.textContent.length > 0){
                cmp.innerHTML = 
`<label for="${"area_"+qtd}">${clonedContent.textContent}</label>
<textarea id="${"area_"+qtd}" rows="5" cols="30" class="pd-textarea"/></textarea>`;
            }else{
                cmp.innerHTML = 
`<label for="${"area_"+qtd}">${"TextArea-"+(qtd+1)}</label>
<textarea id="${"area_"+qtd}" rows="5" cols="30" class="pd-textarea"/></textarea>`;                
            }
            return cmp;
        }
        if( comp === 'checkBox'){
            const els = document.querySelectorAll('[type="checkbox"]');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');
            cmp.className = "pd-checkbox";
            if( clonedContent && clonedContent.textContent.length > 0){
                cmp.innerHTML = 
`<input type="checkbox" id="${"cbox_"+qtd}"/>
<label for="${"cbox_"+qtd}">${clonedContent.textContent}</label>`;
            }else{
                cmp.innerHTML = 
`<input type="checkbox" id="${"cbox_"+qtd}" />
<label for="${"cbox_"+qtd}">${"CheckBox-"+(qtd+1)}</label>`;
                
            }
            return cmp;
        }
        if( comp === 'checkGroup'){
            const els = document.getElementsByTagName('fieldset');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');
            let title = ( clonedContent && clonedContent.textContent.length > 0)
                ?clonedContent.textContent
                : "CheckGroup-"+(qtd+1);            
            const html = 
`<fieldset class="pd-checkbox">
    <legend>${title}</legend>
    <input type="checkbox" id="apple" name="fruit[]" value="apple">
    <label for="apple">Apple</label><br>
    <input type="checkbox" id="banana" name="fruit[]" value="banana">
    <label for="banana">Banana</label><br>
    <input type="checkbox" id="cherry" name="fruit[]" value="cherry">
<label for="cherry">Cherry</label>
</fieldset>`;
            cmp.innerHTML = html;
            return cmp;
        }
        if( comp === 'radioGroup'){
            const els = document.getElementsByTagName('fieldset');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');
            let title = ( clonedContent && clonedContent.textContent.length > 0)
                ?clonedContent.textContent
                : "RadioGroup-"+(qtd+1);            
            const html = 
`<fieldset class="pd-checkbox">
<legend>${title}</legend>
  <input type="radio" id="apple" name="fruit" value="apple" checked>
  <label for="apple">Apple</label>
  <input type="radio" id="banana" name="fruit" value="banana">
  <label for="banana">Banana</label>
  <input type="radio" id="cherry" name="fruit" value="cherry">
  <label for="cherry">Cherry</label>
</fieldset>`;
            cmp.innerHTML = html;
            return cmp;
        }
        if( comp === 'uploadField'){
            buscaCodigoRefUpload();
            const els = document.querySelectorAll('[type="file"]');
            let qtd = els?els.length:0;
            const cmp = document.createElement('div');            
            if( clonedContent && clonedContent.textContent.length > 0){
                cmp.innerHTML = 
`<label for="${"file"+qtd}">${clonedContent.textContent}</label>
<input type="file" id="${"file_"+qtd}" class="pd-field"/>`;
            }else{
                cmp.innerHTML = 
`<label for="${"file_"+qtd}">${"Campo Upload-"+(qtd+1)}</label>
<input type="file" id="${"file_"+qtd}" class="pd-field" accept="image/png, image/jpeg, image/webp"/>`;
                
            }
            return cmp;
        }
        const cmp = document.createElement('p');
        cmp.setAttribute("id", "paraRemover");
        cmp.textContent = "Desconhecido";
        return cmp 
    }

    return (
        <React.Fragment>
            <Tooltip title="Componentes Formulário">
                <IB
                    onClick={handleClick}
                    size="small"
                >
                    <Wysiwyg />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense>                    
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('textfield')}>
                        <ListItemText primary="TextField" secondary="Campo de texto" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('textarea')}>
                        <ListItemText primary="TextArea" secondary="Campo de texto em area" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('checkBox')}>
                        <ListItemText primary="CheckBox" secondary="Componente de marcação" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('checkGroup')}>
                        <ListItemText primary="CheckGroup" secondary="Componente de marcação em grupo" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('radioGroup')}>
                        <ListItemText primary="RadioGroup" secondary="Componente de escolha em grupo" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('uploadField')}>
                        <ListItemText primary="UploadField" secondary="Campo de upload" />
                    </ListItem>
                    <Divider/>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => handleAddComponente('btn')}>
                        <ListItemText primary="Botão" secondary="Componente botão" />
                    </ListItem>
                </List>
                
            </Popover>

            <Dialog
                open={openCode}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="modelo-codigo"
                role="alertdialog"
            >
                <DialogTitle id="alert-dialog-title">
                {"Modelo de codigo"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="modelo-codigo">
                    <div className='pd-code'>
                        {code}
                    </div>
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCode} autoFocus>
                        Ok
                    </Button>                    
                </DialogActions>
            </Dialog>
            
        </React.Fragment>
    )
}